import React, { Fragment } from "react";
import BackgroundJobsTable from "containers/backgroundJobsTable";

export default function BackgroundJobsPage() {
  return (
    <Fragment>
      <BackgroundJobsTable />
    </Fragment>
  );
}
